import { useNavigate } from "react-router";

import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

interface DiscardChangesDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  backPath: string;
  ticketKey?: string;
}

export function DiscardChangesDialog({ open, onOpenChange, backPath, ticketKey }: DiscardChangesDialogProps) {
  const navigate = useNavigate();

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Discard changes?</AlertDialogTitle>
          <AlertDialogDescription>
            {ticketKey ? (
              <>
                You have unsaved changes to <span className="font-mono text-xs font-semibold text-foreground">{ticketKey}</span>. If you leave now they will be lost.
              </>
            ) : (
              "You have unsaved changes. If you leave now your new ticket will be lost."
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Keep editing</AlertDialogCancel>
          <AlertDialogAction variant="destructive" onClick={() => navigate(backPath)}>
            Discard changes
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
